import { render, staticRenderFns } from "./CredenciamentoAtualizacaoAcoesExcluir.vue?vue&type=template&id=19bc6d43"
import script from "./CredenciamentoAtualizacaoAcoesExcluir.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoAcoesExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports